<template>
  <component :is="componentType" :map="map" :source="source" />
</template>
<script>
import SimpleMapCard from "./SimpleMapCard";
import CondensedMapCard from "./CondensedMapCard";
export default {
  props: {
    map: Object,
    condensed: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: "maps",
    },
  },
  components: {
    SimpleMapCard,
    CondensedMapCard,
  },
  computed: {
    componentType() {
      return this.condensed ? "CondensedMapCard" : "SimpleMapCard";
    },
  },
};
</script>
